// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___C6VZy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Editor/Editor.scss
// module id = 991
// module chunks = 0